import Glide from "@glidejs/glide";

export default class MagazineSlider {
    
    static get selector() {
        return '.magazineSlider';
    }

    constructor(el) {
        this.el = el;

        this.eSlider = this.el.querySelector('.magazineSlider__slider');
        this.eSlides = this.el.querySelectorAll('.magazineSlider__slide');
        this.eLink = this.el.querySelector('.magazineSlider__link');

        this.slider = new Glide(this.eSlider, {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            gap: 0

        });
        this.slider.mount();

        this.slider.on(['mount.after', 'run'], this.slideChange.bind(this))
    }

    slideChange(e) {
        let index = this.slider.index;
        let element = this.eSlides[index];
        let url = element.dataset.magazineUrl;
        this.eLink.setAttribute('href', url);
    }

    setEvents() {

    }
}